/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { EmailServerSettingsDialogParams } from './email-server-settings-dialog-params';

export const EmailServerSettingsDialogParamsContext = createContext<EmailServerSettingsDialogParams>({} as EmailServerSettingsDialogParams);
